/** Badge variant for a job / project / generation status string. */
export type StatusTone = "success" | "info" | "warning" | "destructive" | "secondary";

const SUCCESS = new Set([
  "completed",
  "complete",
  "done",
  "success",
  "succeeded",
  "active",
  "ready",
  "published",
  "approved",
  "paid",
  "captured",
  "enabled",
  "connected",
]);

const DESTRUCTIVE = new Set([
  "failed",
  "failure",
  "error",
  "errored",
  "cancelled",
  "canceled",
  "expired",
  "rejected",
  "disabled",
  "refunded",
]);

const WARNING = new Set(["past_due", "partial", "warning", "halted", "retrying", "stale", "low"]);

const NEUTRAL = new Set(["pending", "queued", "draft", "paused", "idle", "scheduled", "created", "inactive"]);

/**
 * Map any status to a doodle badge tone. In-flight states (generating_*,
 * processing, running, rendering…) read as `info`; unknown strings fall back
 * to `secondary`.
 */
export function statusTone(status: string | null | undefined): StatusTone {
  if (!status) return "secondary";
  const s = status.toLowerCase().trim().replace(/[\s-]+/g, "_");
  if (SUCCESS.has(s)) return "success";
  if (DESTRUCTIVE.has(s)) return "destructive";
  if (WARNING.has(s)) return "warning";
  if (NEUTRAL.has(s)) return "secondary";
  if (/^(generating|processing|running|rendering|ingesting|writing|transcribing|verifying|uploading|mixing|assembling|training|in_progress)/.test(s)) {
    return "info";
  }
  return "secondary";
}
